<div
  class="library"
  #library
  infiniteScroll
  [scrollWindow]="false"
  [infiniteScrollDistance]="2"
  [infiniteScrollUpDistance]="1.5"
  [infiniteScrollThrottle]="50"
  (scrolled)="onNewScrollPosition()"
>
  @if (uploader.queue && uploader.queue.length === 0) {
    <div
      class="library-container"
      celoFileDrop
      [uploader]="uploader"
      (fileOver)="dropZoneState($event)"
      (filesDropped)="handleDrop($event)"
      [ngClass]="{ valid: dropZoneActive === 'valid' }"
    >
      <div class="drop-highlight">
        <div>
          <i class="material-icons icon-xxl">cloud_upload</i>
          <div>UPLOAD</div>
        </div>
      </div>
      <div class="library-tools" #tools>
        <div class="search-bar">
          <div class="topbar-input">
            <app-celo-topbar-search-input
              [placeholder]="'Search by Patient ID or Patient Name'"
              (doSearch)="queryChange($event)"
            >
            </app-celo-topbar-search-input>
          </div>
        </div>
        <div class="drop-zone">
          <app-drop-zone
            [type]="'documents'"
            [formats]="['pdf']"
            [uploader]="uploader"
          ></app-drop-zone>
        </div>
        <div class="toolbar">
          <app-library-secondbar-toolbar
            (startSelect)="startSelect()"
            (cancelSelect)="cancelSelect()"
            [pageName]="'Documents'"
            [singleFileId]="
              getSelectedCount() === 1 && getFirstSelected()
                ? getFirstSelected().payload.id
                : ''
            "
            [singleFileName]="
              getFirstSelected()
                ? getFirstSelected().payload.fileName + '.pdf'
                : 'Patient File.pdf'
            "
            [singleFileType]="'document'"
            [selectedFileCount]="getSelectedCount()"
          >
          </app-library-secondbar-toolbar>
        </div>
      </div>
      <div
        class="library-list"
        data-testid="library-document-results"
        [attr.aria-busy]="loading"
        [style.height.px]="library.offsetHeight - tools.offsetHeight"
      >
        @if (loading && (!documents || documents.length === 0)) {
          <app-empty-state [isLoading]="true" [message]="LOADING">
          </app-empty-state>
        }
        @if (!loading && documents.length === 0) {
          <div>
            @if (!searchTerm) {
              <app-empty-state
                [title]="'Document Sharing'"
                [message]="'Safely share patient documents with colleagues and connections.'"
                [isEmpty]="true"
                [image]="'empty_states/empty-state-documents.svg'"
              ></app-empty-state>
            }
            @if (searchTerm) {
              <app-empty-state
                [title]="'No results found'"
                [message]="'Try searching by Patient ID, Patient Name or Document Name.'"
                [isEmpty]="true"
                [image]="'no-results-found-directory-v2.svg'"
              ></app-empty-state>
            }
          </div>
        }
        @if (documents.length > 0) {
          <div>
            <div class="group">
              <div class="list row">
                @for (document of documents; track document) {
                  <div
                    #tile
                    data-testid="library-document-tile"
                    [attr.data-document-id]="document.payload.id"
                    class="col-xs-12 col-sm-6 col-lg-4 col-xl-3 item"
                    [style.height.px]="tile.offsetWidth"
                  >
                    <div class="grow-shadow card">
                      <app-document
                        [libItem]="document"
                        (selected)="onSelected($event)"
                        [ownFile]="userId === document.payload.creator.userId"
                      ></app-document>
                    </div>
                  </div>
                }
              </div>
            </div>
            @if (loading && !hideLoadMore) {
              <div>
                <app-empty-state
                  [isLoading]="true"
                  [message]="'Loading Documents'"
                >
                </app-empty-state>
              </div>
            }
            @if (hideLoadMore) {
              <div class="list-end">- That's all -</div>
            }
          </div>
        }
      </div>
    </div>
  }
  @if (uploader.queue && uploader.queue.length !== 0) {
    <div>
      <app-file-upload-preview
        (closeMe)="closeUpload()"
        [type]="'Documents'"
        [isInSecureLibrary]="true"
        [uploader]="uploader"
      >
      </app-file-upload-preview>
    </div>
  }
</div>
